import "/src/style/generalStyle.css";
import "/src/style/tierlistStyle.css";

export function TierlistView(props) {
    return (
        <div className="tierListDiv">
            <h1>Tierlist</h1>
            <table className="tierListBlock">
                <tbody>
                    <tr className="tierListRow tierList10">
                        {
                        props.ratings
                            ?
                        props.ratings[9].map(renderRatingsCB)
                            :
                        <td/>
                        }
                    </tr>
                    <tr className="tierListRow tierList9">
                        {
                        props.ratings
                            ?
                        props.ratings[8].map(renderRatingsCB)
                            :
                        <td/>
                        }
                    </tr>
                    <tr className="tierListRow tierList8">
                        {
                        props.ratings
                            ?
                        props.ratings[7].map(renderRatingsCB)
                            :
                        <td/>
                        }
                    </tr>
                    <tr className="tierListRow tierList7">
                        {
                        props.ratings
                            ?
                        props.ratings[6].map(renderRatingsCB)
                            :
                        <td/>
                        }
                    </tr>
                    <tr className="tierListRow tierList6">
                        {
                        props.ratings
                            ?
                        props.ratings[5].map(renderRatingsCB)
                            :
                        <td/>
                        }
                    </tr>
                    <tr className="tierListRow tierList5">
                        {
                        props.ratings
                            ?
                        props.ratings[4].map(renderRatingsCB)
                            :
                        <td/>
                        }
                    </tr>
                    <tr className="tierListRow tierList4">
                        {
                        props.ratings
                            ?
                        props.ratings[3].map(renderRatingsCB)
                            :
                        <td/>
                        }
                    </tr>
                    <tr className="tierListRow tierList3">
                        {
                        props.ratings
                            ?
                        props.ratings[2].map(renderRatingsCB)
                            :
                        <td/>
                        }
                    </tr>
                    <tr className="tierListRow tierList2">
                        {
                        props.ratings
                            ?
                        props.ratings[1].map(renderRatingsCB)
                            :
                        <td/>
                        }
                    </tr>
                    <tr className="tierListRow tierList1">
                        {
                        props.ratings
                            ?
                        props.ratings[0].map(renderRatingsCB)
                            :
                        <td/>
                        }
                    </tr>
                </tbody>
            </table>
        </div>
    );
    function renderRowsCB(array) {
        return <tr className={array.Index}>
            {
            array
                ?
            array.map(renderRatingsCB)
                :
            <td/>
            }
        </tr>
    }
    function renderRatingsCB(movie) {
        return <td id={movie.imdbid} className="movieCard">
            <img src={movie.imgUrl ? movie.imgUrl : null} className="movieImage"></img>
            <span className="movieTitle">{movie.title}</span>
        </td>
    }
}